<template>
    <div>
        <h1>Frontend using Vue</h1>
        <p>Congrats! Frontend using Vue is a great stack!</p>

        <FrontendTechReq></FrontendTechReq>

        <h3>Vue-specific requirements</h3>
        <ul>
            <li>Use <i>VueRouter</i> for routing</li>
            <li>Split your app into multiple views</li>
            <li>Split your views into multiple reusable compontents</li>
            <li>Move complex business logic out of the views and import them instead</li>
            <li>Use props to send data to your components</li>
            <li>Try to have at least one component using <i>slot(s)</i></li>
        </ul>
        <h3>This should get you started</h3>
        <p>Use <a href="https://cli.vuejs.org/" target="_blank">Vue-CLI</a> to get started</p>
        <CodeBox><pre>npm install -g @vue/cli
vue create
</pre></CodeBox>
        <FrontendNav></FrontendNav>
    </div>
</template>


<script>
import FrontendNav from '@/components/FrontendNav.vue'
import FrontendTechReq from '@/components/FrontendTechReq.vue'
import CodeBox from '@/components/CodeBox.vue'

export default {
    name: 'FrontendVue',
    components: {
        FrontendNav,
        FrontendTechReq,
        CodeBox
    }
}
</script>